var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kgk-password-reset"},[_c('PasswordResetForm',{attrs:{"reset-code":_vm.$route.params.code}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }